import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function GuaranteePrice(props) {
  const { lang } = useContext(ConfiguratorContext)

  return (
    <div className='guarantee-price'>
      <div className='config-overview__title-price'>
        <>{new Intl.NumberFormat(lang).format(props.guarantee_price)}</>
        {' '}
        {props.cash_string}
      </div>
    </div>
  )
}
